import styles from './WelcomePage.module.css';

export default function WelcomePage() {
  return <h1 className={styles.heading}>Welcome to Phonebook application</h1>;
}
